import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slice/authSlice";
import learnReducer from "./slice/learnSlice";
import plannerReducer from "./slice/plannerSlice";
import planSlice from "./slice/planSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    learn: learnReducer,
    planner: plannerReducer,
    plan: planSlice,
  },
});
